import * as contentful from 'contentful';

const config = {
    space: process.env.CTF_SPACE_ID,
    accessToken: process.env.CTF_CDA_ACCESS_TOKEN,
};

export const createContentfulClient = (options = {}) => {
    return contentful.createClient({ ...config, ...options });
};
